import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { productApi, type ProductDashboard } from '../../api/products';

export function ProductDashboardPage() {
  const [dashboard, setDashboard] = useState<ProductDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void productApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/products" className="text-sm text-slate-600 hover:underline">← Products</Link>
      <h1 className="mt-4 text-2xl font-semibold">Product Dashboard</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {Object.entries(dashboard?.stats ?? {}).map(([key, value]) => (
          <div key={key} className="rounded-xl border bg-white p-4">
            <p className="text-sm text-slate-500">{key.replace(/_/g, ' ')}</p>
            <p className="mt-1 text-2xl font-semibold">{String(value)}</p>
          </div>
        ))}
      </div>
      {!dashboard?.stats && !error && <p className="mt-6 text-slate-500">No dashboard stats yet.</p>}
    </div>
  );
}
